/**
 * Countdown Timer
 */
document.addEventListener('DOMContentLoaded', () => {
  const countdownTimers = document.querySelectorAll('.countdown-timer');

  if (countdownTimers.length === 0) {
    return;
  }

  /**
   * @param {number} number - Liczba do sprawdzenia.
   * @param {string} one - Forma pojedyncza (np. "sekunda").
   * @param {string} few - Forma mnoga (np. "sekundy").
   * @param {string} many - Forma dopełniacza (np. "sekund").
   * @returns {string} Poprawna etykieta.
   */
  const getPluralForm = (number, one, few, many) => {
    number = Math.abs(number);
    if (number === 1) {
      return one;
    }
    const lastDigit = number % 10;
    const lastTwoDigits = number % 100;
    if (
      lastDigit >= 2 &&
      lastDigit <= 4 &&
      (lastTwoDigits < 12 || lastTwoDigits > 14)
    ) {
      return few;
    }
    return many;
  };

  countdownTimers.forEach((timer) => {
    const targetDateStr = timer.dataset.targetDate;
    const expiredText = timer.dataset.expiredText;

    const labels = {
      days: {
        one: timer.dataset.labelDaysOne,
        few: timer.dataset.labelDaysFew,
        many: timer.dataset.labelDaysMany,
      },
      hours: {
        one: timer.dataset.labelHoursOne,
        few: timer.dataset.labelHoursFew,
        many: timer.dataset.labelHoursMany,
      },
      minutes: {
        one: timer.dataset.labelMinutesOne,
        few: timer.dataset.labelMinutesFew,
        many: timer.dataset.labelMinutesMany,
      },
      seconds: {
        one: timer.dataset.labelSecondsOne,
        few: timer.dataset.labelSecondsFew,
        many: timer.dataset.labelSecondsMany,
      },
    };

    if (!targetDateStr) {
      console.error('Target date is not set for countdown timer:', timer);
      return;
    }

    const targetTime = new Date(targetDateStr.replace(' ', 'T')).getTime();

    if (isNaN(targetTime)) {
      console.error('Invalid date format for countdown:', targetDateStr);
      return;
    }

    const daysEl = timer.querySelector('[data-days]');
    const hoursEl = timer.querySelector('[data-hours]');
    const minutesEl = timer.querySelector('[data-minutes]');
    const secondsEl = timer.querySelector('[data-seconds]');

    const daysLabelEl = timer.querySelector('[data-label-days]');
    const hoursLabelEl = timer.querySelector('[data-label-hours]');
    const minutesLabelEl = timer.querySelector('[data-label-minutes]');
    const secondsLabelEl = timer.querySelector('[data-label-seconds]');

    const updateCountdown = () => {
      const now = new Date().getTime();
      const distance = targetTime - now;

      if (distance < 0) {
        clearInterval(interval);
        if (expiredText) {
          timer.innerHTML = `<div class="countdown-expired">${expiredText}</div>`;
        } else {
          daysEl.textContent = '00';
          hoursEl.textContent = '00';
          minutesEl.textContent = '00';
          secondsEl.textContent = '00';
          daysLabelEl.textContent = labels.days.many;
          hoursLabelEl.textContent = labels.hours.many;
          minutesLabelEl.textContent = labels.minutes.many;
          secondsLabelEl.textContent = labels.seconds.many;
        }
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      const pad = (num) => String(num).padStart(2, '0');

      daysEl.textContent = pad(days);
      hoursEl.textContent = pad(hours);
      minutesEl.textContent = pad(minutes);
      secondsEl.textContent = pad(seconds);

      daysLabelEl.textContent = getPluralForm(
        days,
        labels.days.one,
        labels.days.few,
        labels.days.many
      );
      hoursLabelEl.textContent = getPluralForm(
        hours,
        labels.hours.one,
        labels.hours.few,
        labels.hours.many
      );
      minutesLabelEl.textContent = getPluralForm(
        minutes,
        labels.minutes.one,
        labels.minutes.few,
        labels.minutes.many
      );
      secondsLabelEl.textContent = getPluralForm(
        seconds,
        labels.seconds.one,
        labels.seconds.few,
        labels.seconds.many
      );
    };

    const interval = setInterval(updateCountdown, 1000);
    updateCountdown();
  });
});
